import {api, apiFetch} from '@/api/setup';
import {ISongJson} from "../../../server/src/modules/shared-interfaces";
import {cacheOrFetch, cacheOrFetchUpdatedResponse} from "@/api/cache";



export async function getAll(): Promise<ISongJson[]> {
    const response = await cacheOrFetch(api('/songs'));
    const data:ISongJson[] = await response;
    return data;
}

export async function getById(id: number, fnUpdate:any): Promise<ISongJson> {
    const response = await cacheOrFetchUpdatedResponse(api(`/songs/${id}`), fnUpdate);
    const data:ISongJson = await response;
    return data;
}


export async function save(song:ISongJson) {
    let data;
    if (song.id) {
       data = await apiFetch(`/songs/${song.id}`, 'put', song);
    } else {
      data = await apiFetch(`/songs`, 'post', song);
    }
    return await data.json()
}